/**
 * Device Info from hexnode
 */
export interface DeviceInfo {
    deviceId?: string;
    deviceNotes?: string;
    imei?: string;
    meid?: string;
    phoneNo?: string;
    phoneNumber?: string;
    phoneNumberSim1?: string;
    phoneNumberSim2?: string;
    serialNumber?: string;
    udid?: string;
    lastUpdatedTimestamp?: number;
}

export const DeviceInfoKey = 'deviceInfo';
export const DeviceCompanyPhoneKey = 'deviceCompanyPhoneId';
